export default {
    deviceManagement: 'จัดการตำแหน่งสแกนใบหน้า',
    searchByBureau: 'ค้นหาสำนักงาน',
    search: 'ค้นหา',
    edit: 'แก้ไข',
    bureau: 'สำนักงาน',
    acronym: 'ชื่อย่อสำนักงาน',
    organization: 'สายงาน',
    locationAccess: 'ตำแหน่งสแกนใบหน้า',
    totalEmployee: 'พนักงานทั้งหมด',
    action: '',
    allOrganization: 'สายงานทั้งหมด'
}
